import { createSection } from '../createSection'

/**
 * Default section for a button
 *
 * @public
 */
export const buttonLabel = createSection('default', null)
